import script from "./Home.vue?vue&type=script&setup=true&lang=ts"
export * from "./Home.vue?vue&type=script&setup=true&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=ee4e2ec2&lang=scss&scoped=true"

import exportComponent from "X:\\Git\\Patreon-Linker\\patreon-linker\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee4e2ec2"]])

export default __exports__